var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"success"},[_c('img',{attrs:{"src":require("../../../static/success-icon.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("支付成功")]),_vm._v(" "),_c('p',[_vm._v("代付订单已支付完成，快去通知亲友吧")]),_vm._v(" "),_c('span',{on:{"click":_vm.checkCity}},[_vm._v("点击查看海量好书>")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fc812d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/paySuccess/index.vue
// module id = null
// module chunks = 